import { Close } from "@mui/icons-material";
import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import Styles from "./ViewDoc.module.css";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import Loader from "../../../../commons/Loader/Loader";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";
import { fetchViewDocumentHistory } from "../../../../Redux/Slices/CapacitySlice";
import { getDocumentUrlByLedgerId } from "../../../../Services/ApiCalling/banking";

const ViewDoc = ({
  open,
  handleClose,
  connectionId,
  viewDocData,
  activeCounterparty,
  useSecondaryAccent = false,
}) => {
  const dispatch = useDispatch();
  const { documentViewHistory, loading, error } = useSelector(
    (state) => state.CapacitySlice,
  );

  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    if (connectionId) {
      dispatch(fetchViewDocumentHistory(connectionId));
    }
  }, [dispatch, connectionId]);

  useEffect(() => {
    if (documentViewHistory && Array.isArray(documentViewHistory)) {
      const filtered = documentViewHistory.filter(
        (doc) =>
          doc.documentType && doc.documentType.toUpperCase() !== "INVALID",
      );
      setDataLoaded(filtered);
    }
  }, [documentViewHistory]);

  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState(null);

  const handleViewDoc = async (id) => {
    try {
      const response = await getDocumentUrlByLedgerId(id);
      const url = response.data;
      if (url) {
        const doc = dataLoaded.find((d) => d.id === id);
        setPreviewFileUrl(url);
        setSelectedDocumentId(id);
        setSelectedFileName(doc?.filename || null);
        setPreviewModal(true);
      } else {
        alert("Document URL not found");
      }
    } catch (err) {
      alert("Could not fetch document URL.");
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
    setSelectedDocumentId(null);
    setSelectedFileName(null);
  };
  const formatDocType = (type) => {
    if (!type) return "";
    if (type.toUpperCase() === "RANDOM") return "Others";
    return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div
          className={`popupModal ${Styles.createEditModalCont} ${
            useSecondaryAccent ? "secondaryAccent" : ""
          }`}
        >
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">View Document</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.docContainer}>
            {/* Header Row */}
            <div className={`${Styles.docHeaderRow} ${Styles.docRow1}`}>
              <div className={`${Styles.docCol} ${Styles.companyName}`}>
                Entity Name
              </div>

              <div className={`${Styles.docCol} ${Styles.type}`}>Type</div>

              <div className={`${Styles.docCol} ${Styles.createdAt}`}>
                Uploaded At
              </div>
              <div className={`${Styles.docCol} ${Styles.filename}`}>
                File Name
              </div>
              <div className={`${Styles.docCol} ${Styles.view}`}>View</div>
            </div>

            <div className={Styles.docContentScroll}>
              {loading ? (
                <div className={Styles.loadingRow}>
                  <Loader />
                </div>
              ) : error ? (
                <p className={Styles.error}>{error}</p>
              ) : dataLoaded?.length > 0 ? (
                dataLoaded.map((doc) => (
                  <div className={Styles.docRow} key={doc.id}>
                    <div
                      className={`${Styles.docCol} ${Styles.companyName} ${Styles.docContent}`}
                    >
                      {doc.entityName}
                      {/* {doc.listingId} */}
                    </div>

                    {/* New Document Type Column */}
                    <div
                      className={`${Styles.docCol} ${Styles.type} ${Styles.docContent}`}
                      style={{ textTransform: "uppercase" }}
                    >
                      {formatDocType(doc.documentType) || "-"}
                    </div>

                    <div
                      className={`${Styles.docCol} ${Styles.createdAt} ${Styles.docContent}`}
                    >
                      {new Date(doc.createdAt).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </div>
                    <div
                      className={`${Styles.docCol} ${Styles.filename} ${Styles.docContent}`}
                    >
                      {doc.filename}
                    </div>
                    <div
                      className={`${Styles.docCol} ${Styles.view} ${Styles.docContent}`}
                    >
                      <span
                        onClick={() => handleViewDoc(doc.id)}
                        className={Styles.viewLink}
                        style={{ cursor: "pointer" }}
                      >
                        <ViewIcon />
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <>
                  <div
                    className={`display_flex_row_center ${Styles.noDataFound}`}
                  >
                    No document history found.
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal>
      <PreviewModal
        open={previewModal}
        onClose={handleClosePreview}
        fileUrl={previewFileUrl}
        disableDownload={true}
        documentId={selectedDocumentId}
        name={selectedFileName}
      />
    </>
  );
};

export default ViewDoc;
